import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/carousel/tile.js';
import { navigateInternally } from 'utils/bolt';
import Store from 'store/store';
import { trackTileEngagement } from 'utils/track.js';

export default class Tile extends BaseComp.default {
	onTileClick(e) {
		const title = this.props.data?.title;
		const path = this.props.data?.path;
		const textOverlay = this.props.data?.textOverlay?.content;
		const videoOverlay = this.props.data?.videoOverlay;

		if ((!path && !textOverlay && !videoOverlay) || !this.tile.contains(e.target) || this.buttons?.base?.contains(e.target) || e.target?.className?.includes && e.target.className.includes('hubTextOverlay')) {
			return;
		}
		trackTileEngagement(title);
		if (textOverlay) {
			this.toggleTextOverlay(true);
			return;
		}
		if (videoOverlay) {
			Store.emit('ENABLE_TRAILER_OVERLAY', videoOverlay.video);
			return;
		}
		
		if (path.startsWith('http') || path.startsWith('mailto:')) {
			let link = document.createElement('a');
			link.href = path;
			link.target = '_blank';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else {
			navigateInternally(path);
		}
	}
}
